import { Navigate } from "react-router-dom";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import { useAcomAdmin } from "@/hooks/use-acom-admin";

interface RequireAcomAdminProps {
    children: React.ReactNode;
}

/**
 * Route guard that only renders children if the current user is an ACOM admin.
 * Redirects to /home if not an admin. Shows loading indicator while checking.
 */
export function RequireAcomAdmin({ children }: RequireAcomAdminProps) {
    const { isAcomAdmin, isLoaded } = useAcomAdmin();

    if (!isLoaded) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <LoadingIndicator size="lg" label="Loading..." />
            </div>
        );
    }

    if (!isAcomAdmin) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
}
